import {twMerge} from '@sdox/utils'

import {Scrim} from './Scrim'
import {LazyImage} from '../LazyImage'

import type {LazyImageProps} from '../LazyImage'
import type {ClassNameValue} from 'tailwind-merge'

export type AspectRatio = '1/1' | '2/3' | '3/2' | '3/4' | '4/3' | '16/9' | '16/10'

export interface MediaProps extends LazyImageProps {
  aspectRatio?: AspectRatio
  scrim?: boolean
  imageClassName?: ClassNameValue
}

export const aspectRatiosClasses: Record<NonNullable<MediaProps['aspectRatio']>, ClassNameValue> = {
  '1/1': 'aspect-[1/1]',
  '2/3': 'aspect-[2/3]',
  '3/2': 'aspect-[3/2]',
  '3/4': 'aspect-[3/4]',
  '4/3': 'aspect-[4/3]',
  '16/9': 'aspect-[16/9]',
  '16/10': 'aspect-[16/10]',
}

export const Media = ({
  src,
  alt,
  aspectRatio,
  scrim = false,
  className,
  imageClassName,
  ...restProps
}: MediaProps) => (
  <div className={twMerge('relative size-full overflow-hidden', className)}>
    {scrim ? <Scrim /> : null}
    <LazyImage
      src={src ?? null}
      alt={alt}
      className={twMerge(
        'size-full object-cover object-center',
        aspectRatio ? aspectRatiosClasses[aspectRatio] : '',
        imageClassName,
      )}
      {...restProps}
    />
  </div>
)
